export default "__VITE_ASSET__839859c3__"